import React from 'react';

const cases = [
  {
    emoji: '🏢',
    label: 'Sales Teams',
    headline: 'Replace 3 SDRs worth of cold outreach',
    body: 'AI handles first-touch calls, qualifies intent, handles objections, and books calendar slots directly. Your closers only talk to people who are ready.',
  },
  {
    emoji: '📣',
    label: 'Marketing Agencies',
    headline: 'Run outbound for clients at near-zero cost',
    body: 'Launch campaigns for multiple clients simultaneously. $0.09/min means you can offer outbound as a service with healthy margins. White-label coming soon.',
  },
  {
    emoji: '🔬',
    label: 'Product & Research Teams',
    headline: '50 customer interviews in a single afternoon',
    body: 'Voice Research synthesizes findings into a structured report with key themes, sentiment breakdown, and direct quotes — faster than any research firm.',
  },
  {
    emoji: '🏪',
    label: 'Small Businesses',
    headline: 'Punch above your weight on outreach',
    body: 'No budget for a sales team? CallPilot is your always-on calling agent. Follow up every lead, reactivate dormant customers, and fill your pipeline automatically.',
  },
];

export function UseCases() {
  return (
    <section id="use-cases" className="py-16 px-6">
      <div className="mx-auto max-w-6xl">
        <div className="text-center mb-10">
          <span className="text-xs font-mono tracking-widest uppercase text-indigo-400 mb-3 block">Who it's for</span>
          <h2 className="text-2xl md:text-3xl font-bold text-white tracking-tight">
            Built for teams that can't afford to miss a lead
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {cases.map((c) => (
            <div
              key={c.label}
              className="rounded-2xl border border-white/[0.08] bg-white/[0.03] p-6 hover:bg-white/[0.06] hover:border-indigo-500/20 transition-all group"
            >
              <div className="text-3xl mb-4">{c.emoji}</div>
              <div className="text-xs font-mono uppercase tracking-widest text-indigo-400 mb-1">{c.label}</div>
              <div className="text-sm font-semibold text-white mb-2">{c.headline}</div>
              <p className="text-sm text-zinc-400 leading-relaxed">{c.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
